<div class="{{getClass()}}">
  <ng-template contentHost></ng-template>
</div>
